module.exports = __webpack_public_path__ + "static/media/home.c2242499.svg";